import Vue from 'vue'
import app from './app.vue'
import router from './router'
import store from './store/store'
import Vuebar from 'vuebar'
import api from '@/lib/api'

import Icon from './components/global/icon'
import _ from 'lodash'
import VueSelect from 'vue-cool-select'
import vClickOutside from "v-click-outside";
import VueGtm from "vue-gtm"

api.init(store)

Vue.component('icon', Icon)
Vue.use(Vuebar)

Vue.use(VueSelect, {
  theme: 'bootstrap'
})

Vue.use(vClickOutside)

Vue.use(VueGtm, {
  id: "GTM-KLMBNGM",
  enabled: process.env.VUE_APP_ES_ENV == "PROD",
  debug: process.env.VUE_APP_ES_ENV == "DEV",
  loadScript: true,
  vueRouter: router
});

Object.defineProperty(Vue.prototype, '_', { value: _ });

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(app)
}).$mount('#app')

// test jna